import { render, staticRenderFns } from "./CollectiveLesson.vue?vue&type=template&id=ac1b9454&scoped=true"
import script from "./CollectiveLesson.vue?vue&type=script&lang=js"
export * from "./CollectiveLesson.vue?vue&type=script&lang=js"
import style0 from "./CollectiveLesson.vue?vue&type=style&index=0&id=ac1b9454&prod&lang=scss&scoped=true"
import style1 from "./CollectiveLesson.vue?vue&type=style&index=1&id=ac1b9454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1b9454",
  null
  
)

export default component.exports